export default {
	items: [
		/*
		{
			name: 'Dashboard',
			url: '/dashboard',
			icon: 'icon-speedometer',
		},
		{
			name: 'Roles & Permissions',
			url: '/roles',
			icon: 'icon-people',
			permission: 'role-lists'
		},
		{
			name: 'Sites',
			url: '/sites',
			icon: 'cui-home icons',
			permission: 'site-list'
		},
		{
			name: 'Users',
			url: '/users',
			icon: 'fa fa-user-o',
			permission: 'user-list'
		},
		{
			name: 'Logout',
			url: '/logout',
			icon: 'fa fa-sign-out'
		},
		{
			name: 'Download CoreUI',
			url: 'https://coreui.io/react/',
			icon: 'icon-cloud-download',
			class: 'd-sm-block d-md-block d-lg-block',
			variant: 'success',
			attributes: { target: '_blank', rel: "noopener" },
		},
*/

		{
			name: 'Visitor Management System - IST',
			// url: 'https://coreui.io/react/',
			icon: 'icon-home',
			class: 'd-sm-block d-md-block d-lg-none',
			// variant: 'success',
			// attributes: { target: '_blank', rel: "noopener" },

		},
		{
			name: 'Dashboard',
			url: '/dashboard',
			icon: 'icon-speedometer',

		},
		{
			name: 'Visitor Management',
			url: '/visitormanagement/checkins',
			icon: 'icon-people'
		},
		{
			name: 'Reports',
			url: '/reports/incident',
			icon: 'fa fa-bar-chart'
		},
		{
			name: 'Sites',
			url: '/sites',
			icon: 'fa fa-sitemap',
			permission: 'list-sites'

		},
		{
			name: 'Users',
			url: '/users',
			icon: 'fa fa-user-o',
			permission: 'list-users'
		},
		{
			name: 'Notifications',
			url: '/messages',
			icon: 'fa fa-bell',
			permission: 'list-notifications'
		},
		{
			name: 'Logout',
			url: '/logout',
			icon: 'fa fa-sign-out'
		},
	],
};
